import React from 'react';

import { Container } from './styles';

const SignUp: React.FC = () => {
  return (
    <Container>
      <h1>SignUp</h1>
    </Container>
  );
};

export default SignUp;
